import INFTCollections from '../../models/INFTCollections'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import NftSoccerGamesLogo from '../../../../assets/nft-logo/NftSoccerGames.jpg'
import NftSoccerGamesDetail from '../../nftFormats/NftSoccerGames/Detail/NftSoccerGamesDetail'

export const NftSoccerGamesData: INFTCollections[] = [
  {
    id: 'NftSoccerGames',
    tokenAddress: '0xF3c1E16720502Aa49570765883bD5e87d328f481',
    name: 'Nft Soccer Games',
    cardFormat: GeneralCard,
    detailFormat: NftSoccerGamesDetail,
    activityFormat: GeneralActivityDetail,
    category: 2,
    creatorAddress: '0xd2F28D959e6C675d68E547170a850755700a12e9',
    logo: NftSoccerGamesLogo,
    website: 'https://nftsoccergames.com/',
    twitter: 'NftSoccerGames',
    telegram: 'https://t.me/NftSoccerGames',
    discord: 'https://discord.com/invite/tZgUF6D7'
  }
]

export const NftSoccerGamesCategoryData = {
  [NftSoccerGamesData[0].tokenAddress.toLowerCase()]: NftSoccerGamesData[0].category
}
